import { getFunctions, httpsCallable } from "firebase/functions";

import { firebaseApp } from "./firebase";

export type PublicCentralServiceFolder = { acknowledgements: string; caseId: string; coverTitle: string; funeralHomeId: string; lovedOneName: string; music: string; orderOfService: string; publishedAt: string | null; readings: string; status: "published"; updatedAt: string | null };
const functions = getFunctions(firebaseApp, "us-east1");

export async function getPublishedCentralServiceFolder(funeralHomeId: string, caseId: string) {
  const callable = httpsCallable<{ caseId: string; funeralHomeId: string }, PublicCentralServiceFolder>(functions, "getPublishedCentralServiceFolder");
  return (await callable({ caseId, funeralHomeId })).data;
}
